/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import type { ChartConfiguration } from 'chart.js';
import type { DataSet } from '@vdi/walden-shared/modifiers/chart';

export interface DonutChartSignature {
  // The arguments accepted by the component
  Args: {
    ariaLabel: string;
    datasets: DataSet[];
    hasEmptyLastOption?: boolean;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

const dataColors = ['#1F6554', '#0070F5'];
const emptyColor = '#D8ECE7';

export default class DonutChartComponent extends Component<DonutChartSignature> {
  get datasetsWithOptions() {
    return this.args.datasets.map((dataset) => ({
      ...dataset,
      borderWidth: 0,
      backgroundColor: this.args.hasEmptyLastOption
        ? [...dataColors, emptyColor]
        : dataColors,
    }));
  }

  get options(): Partial<ChartConfiguration<'doughnut'>> {
    return {
      type: 'doughnut',
      options: {
        plugins: {
          legend: {
            display: false,
          },
        },
      },
    };
  }
}
